import React from "react";

export class UserUtilities {
  // === DEVELOPER OPTIONS ===
  public get modelHTML() {
    return <section className="font-mono"></section>;
  }

  public get fillCreateFormData() {
    return {
      username: "Test Username",
      email: "testemail@test.com",
      provider: "google",
      active: false,

      password: "",
      confirmPassword: "",
      firstName: "Test First Name",
      lastName: "Test Last Name",

      roles: [],
      depots: [],
    };
  }

  public get apiCalls() {
    return [
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/users",
        requestMethod: "GET",
        callType: "Main Data Fetching",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/user-roles",
        requestMethod: "GET",
        callType: "Secondary Data Fetching",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/depots?type=all&active=true",
        requestMethod: "GET",
        callType: "Secondary Data Fetching",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/users/",
        requestMethod: "POST",
        callType: "Create Form",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/users/recordID",
        requestMethod: "POST",
        callType: "Edit Form",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/users/admin/password",
        requestMethod: "POST",
        callType: "Edit Form (Password Changed)",
      },
      {
        requestURL: "https://openfleetpro-dev-v2.loqusgroup.com/intapi/users/bulkRemove",
        requestMethod: "POST",
        callType: "Data Deletion",
      },
    ];
  }
}
